import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import { svgAsPngUri } from "save-svg-as-png";
import moment from "moment";
import ReactGA from "react-ga4";
import {GACODE, TRACKING_ALLOWED_CLIENTS} from "../../constants/app-constant";
//ReactGA.initialize("your GA measurement id");
import "../Shared/Tickets.sass"

import {
  ARTICLE_TRACKING,
  DASHBOARD,
  DASHBOARD_CONTAINER,
  WIDGET,
} from "../../constants/route-constants";
import {
  httpDelete,
  httpGet,
  httpPost,
  httpPut,
} from "../../utility/requestHelper";
import Loader from "../Shared/Loader";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { ConfirmModal } from "../Shared/Modal";
import {
  DASHBOARD_MESSAGES,
  HTTP_CODES,
  LOGO,
  CLIENT_NAME,
  COOKIE,
} from "../../constants/app-constant";
import { UserDropdown } from "../Shared/UserDropdown";
import DashboardFeeds from "./DashboardFeeds";
import WidgetFilters from "../NewsAndAnalysis/Filters/WidgetFilters";
import {
  DeleteIcon,
  AddWidgetIcon,
  GoBackIcon,
  ArrowDownIcon,
  MenuIcon,
  EmailIcon,
  TicketIcon,
} from "../Icons/icons.component";
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";
import SocialFeeds from "./SocialFeeds";
import { AddWidget } from "./AddWidget";
import ToastMessage from "../Shared/ToastMessage";
import { Button, Dropdown } from "react-bootstrap";
import { DashboardNameModal } from "./DashboardNameModal";
import { WIDGET_TYPES } from "../../constants/static-filter";
import { WidgetList } from "./WidgetList";
import { getCookie } from "../../utility/cookieProvider";
import Tickets from "../Shared/Tickets";
import { fetchTicketList } from "../../actions/tickets-action";

const { DELETED } = HTTP_CODES;

export const Dashboard = function ({ history }) {
  ReactGA.initialize(GACODE);
  const userId = getCookie(COOKIE.CONCEPT_USER_ID)
  const clientId = getCookie(COOKIE.CONCEPT_CLIENT_ID)

  const [graphRefList, setGraphRefList] = useState({});
  const [apiInProgress, setApiInProgress] = useState(true);
  const [widgets, setWidgets] = useState([]);
  const [widgetLoaded, setWidgetLoaded] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filteredWidgets, setFilteredWidgets] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showDashboardDeleteConfirm, setShowDashboardDeleteConfirm] =
    useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [showAddWidgetPopup, setShowAddWidgetPopup] = useState();
  const [widgetCreationStatus, setWidgetCreationStatus] = useState(null);
  const [editWidgetData, setEditWidgetData] = useState(undefined);
  const [dashboardList, setDashboardList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [dashboardNameStatus, setDashboardNameStatus] = useState("");
  const [selectedDashboard, setSelectedDashboard] = useState({});
  const [showTodaysFeedWidget, setShowTodaysFeedWidget] = useState(false);
  const { dashboard_id } = useParams();
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [hasNewTicket, setHasNewTicket] = useState(false);
  const [pagination, setPagination] = useState({});
  const toggleChatbot = () => {
    setIsChatbotOpen((prev) => !prev);
  };

  const location = useLocation();
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const selectedEntity =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.selectedEntity
    ) || {};
  const masterUser =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.masterUser
    );

  const id = selectedClient && selectedClient.id;
  // Send pageview with a custom path
  ReactGA.send({ hitType: "pageview", page: "/dashboard/"+dashboard_id, title: "Client Portal : Dashboard" });
  // Send a custom event
  let concept_uidv1 = getCookie(COOKIE.CONCEPT_USER_ID); 
  console.log("########id:",id);
  if(id != undefined && id != '' && id != null){
    console.log("selectedClient.id00000concept_uid : ",id+"#@#@#"+concept_uidv1);  
    ReactGA.set({ userId: id+".0."+concept_uidv1 });
    ReactGA.set({ 'user_id': id+".0."+concept_uidv1 });
  }

  const enableDownloadFn = (widgetId) => {
    setWidgetLoaded(
      widgetLoaded.map((w) => {
        if (w.id === widgetId) {
          w.loaded = true;
        }
        return w;
      })
    );
  };

  useEffect(() => {
    const tempCurrentDashboard = dashboardList.filter(
      (d) => d.id == dashboard_id
    )[0];
    setSelectedDashboard(tempCurrentDashboard || {});
    return () => {
      localStorage.removeItem("articleIdList");
    };
  }, [dashboardList]);

  useEffect(() => {
    if (id && dashboard_id) {
      const { data } = location;
      if (!data) {
        fetchDashboardsList();
      } else {
        setDashboardList(data);
      }
      fetchWidgets(id);
    }
  }, [id, dashboard_id]);

  useEffect(() => {
    async function fetchData() {
      if(masterUser != undefined && Object.keys(selectedClient).length && userId){
        let tObj = {
          user_type : Object.keys(masterUser).length?0:1,
          user_id : Object.keys(masterUser).length?0:userId,
          perPage : 1,
          page : 0,
          client_id : selectedClient.id,
          list : true,
          master_ids : Object.keys(masterUser).length?masterUser.id:undefined,
          master_user_id : Object.keys(masterUser).length?userId:undefined,
          status : [0,1]
        }
        let tData = await fetchTicketList(tObj)
        if(Object.keys(tData).length){
          setPagination(tData.pagination)
        }
        else{
          setPagination({})
        }
      }
    }
    if(TRACKING_ALLOWED_CLIENTS.includes(clientId)){
      fetchData()
    }
  },[masterUser,selectedClient,userId])

  useEffect(() => {
    selectedDashboard &&
      setShowTodaysFeedWidget(selectedDashboard.show_todays_feed);
  }, [selectedDashboard]);

  const fetchDashboardsList = () => {
    const perPage = 10000;
    const page = 1;

    httpGet(
      `${unifiedEnvConfig.GET_DASHBOARDS_LIST}?client_id=${selectedClient.id}&perPage=${perPage}&page=${page}`
    )
      .then((response) => {
        const { status, data } = response.data;
        if (status === 200) {
          setDashboardList(data);
          // Send a custom event
          // const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
          // console.log("selectedClient.id00000concept_uid : ",selectedClient.id+"#@#@#"+concept_uid);   
          // console.log("selectedClient.id000concept_uid : ",selectedClient.id+"000"+concept_uid);      
          // ReactGA.set({ userId: selectedClient.id+".00000."+concept_uid });
          // ReactGA.set({ 'user_id': selectedClient.id+".00000."+concept_uid });
          // ReactGA.set({ user_id: selectedClient.id+".00000."+concept_uid });
          // ReactGA.event({
          //   category: "user_engagement",
          //   action: "Active Dashboard- "+selectedClient.id+"clientuser"+concept_uid,
          //   label: "Active Dashboard", // optional
          //   //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
          // });
          let concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
          if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
            let locationHrefNew = window.location.href;
            console.log("## selectedClient ## :",selectedClient);
            ReactGA.event({
              category: "Dashboard",
              action: "Dashboard - "+selectedClient.id+".0."+concept_uid,
              label: locationHrefNew, // optional
              //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
            });
          }
        }
      })
      .catch((e) => {
        setDashboardList([]);
        return e;
      });
  };

  function getWidgetsCorrectedToTodaysDate(allWidgets = []) {
    return allWidgets.map((w) => {
      return {
        ...w,
        from_date: new Date(),
        to_date: new Date(),
      };
    });
  }

  function fetchWidgets() {
    setApiInProgress(true);
    httpGet(
      `${unifiedEnvConfig.WIDGET}?client_id=${id}&dashboard_id=${dashboard_id}`
    )
      .then((res) => {
        try {
          if (res && res.data.data) {
            const allWidgets = res.data.data || [];
            setWidgets(allWidgets);
            setFilteredWidgets(getWidgetsCorrectedToTodaysDate(allWidgets));
            let _widgets = [];
            allWidgets.map((widget) => {
              _widgets.push({
                id: widget.id,
                loaded: false,
              });
            });
            setWidgetLoaded(_widgets);
          }
        } catch {
          setWidgets([]);
          setFilteredWidgets([]);
        }
      })
      .finally(() => {
        setApiInProgress(false);
      });
  }

  function onWidgetDelete(id) {
    if (!id) {
      return;
    }
    setDeleteId(id);
    setShowDeleteConfirm(true);
  }

  function onCancelDeleteWidget() {
    setDeleteId("");
    setShowDeleteConfirm(false);
  }

  function deleteWidget() {
    if (!deleteId) {
      return;
    }
    if (deleteId === WIDGET_TYPES.FEED_WIDGET) {
      handleTodayFeedWidgeStatus(false);
      return;
    }
    httpDelete(`${unifiedEnvConfig.WIDGET}/${deleteId}?client_id=${id}`)
      .then(({ status, message }) => {
        if (status === DELETED) {
          const filteredWidgetsData = filteredWidgets.filter(
            (wd) => wd.id !== deleteId
          );
          const widgetsData = widgets.filter((wd) => wd.id !== deleteId);
          setFilteredWidgets(filteredWidgetsData);
          setWidgets(widgetsData);
        } else {
          alert(message || "Error while deleting Widget");
        }
      })
      .catch(() => {
        alert("Error while deleting Widget");
      })
      .finally(() => {
        setDeleteId("");
        setShowDeleteConfirm(false);
      });
  }

  function onCancelDeleteDashboard() {
    setShowDashboardDeleteConfirm(false);
  }

  function deleteDashboard() {
    httpDelete(
      `${unifiedEnvConfig.DELETE_DASHBOARD}/${dashboard_id}?client_id=${id}`
    )
      .then(({ status, message }) => {
        if (status === DELETED) {
          history.push(DASHBOARD);
        } else {
          alert(message || "Error while deleting dashboard");
        }
      })
      .catch(() => {
        alert("Error while deleting dashboard");
      })
      .finally(() => {
        setShowDashboardDeleteConfirm(false);
      });
  }
  const handleFilteredWidget = (_filteredWidgets) => {
    let _widgets = [];
    Array.isArray(_filteredWidgets) &&
      _filteredWidgets.map((widget) => {
        _widgets.push({
          id: widget.id,
          loaded: false,
        });
      });
    setWidgetLoaded(_widgets);
    setFilteredWidgets(_filteredWidgets);
  };

  const handleDropdownClick = (id) => {
    history.push(`${DASHBOARD_CONTAINER}/${id}`);
  };

  const renderSelectedName = () => {
    if (dashboardList && dashboardList.length && dashboard_id) {
      const selectedItem = dashboardList.find(
        (item) => item.id == dashboard_id
      );
      return selectedItem ? selectedItem.name : "";
    }
  };

  function onCancelModalClick() {
    setOpenModal(false);
  }

  const onConfirmName = (e, name) => {
    const { ERROR_OCCURED, NAME_REQUIRED } = DASHBOARD_MESSAGES;
    if (name) {
      httpPost(
        `${unifiedEnvConfig.ADD_DASHBOARD_NAME}?client_id=${selectedClient.id}`,
        {
          name,
        }
      )
        .then((response) => {
          if (response.data.status === 201) {
            setOpenModal(false);
            setDashboardNameStatus("");
            history.push(DASHBOARD_CONTAINER);
          }
        })
        .catch((err) => {
          setDashboardNameStatus(ERROR_OCCURED);
        });
    } else {
      setDashboardNameStatus(NAME_REQUIRED);
    }
  };

  const handleTodayFeedWidgeStatus = (status) => {
    setShowAddWidgetPopup(null);
    if (!status) {
      setShowTodaysFeedWidget(status);
      setShowDeleteConfirm(false);
    }

    httpPut(
      `${unifiedEnvConfig.ADD_DASHBOARD_NAME}/${selectedDashboard.id}?client_id=${selectedClient.id}`,
      {
        name: selectedDashboard && selectedDashboard.name,
        show_todays_feed: status,
      }
    )
      .then(() => {
        setShowTodaysFeedWidget(status);
        setShowAddWidgetPopup(false);
      })
      .catch((e) => console.log("Failed to update dashboard", e));
  };

  function getDateDiff(toDate, fromDate) {
    const t = moment(toDate, "MM-DD-YYYY");
    const f = moment(fromDate, "MM-DD-YYYY");
    const diff = t.diff(f, "days");
    return diff;
  }

  function downloadAll() {
    // console.log("graphRefList", graphRefList);
    setIsDownloading(true);
    const { from_date, to_date } = filteredWidgets[0];
    const FROM_DATE = moment(from_date).format("Do MMMM YYYY");
    const TO_DATE = moment(to_date).format("Do MMMM YYYY");
    const diffInDays = getDateDiff(to_date, from_date);

    const allCanvas = document.getElementsByTagName("canvas");
    const allSvg = [];

    const svgContainer = document.getElementsByClassName(
      "widget-graph-container"
    );

    // if (svgContainer.length) {
    //   svgContainer.forEach((el) => {
    //     const svg = el.querySelectorAll("svg");
    //     if (svg && svg.length) {
    //       allSvg.push(svg[svg.length - 1]);
    //     }
    //   });
    // }

    const pdf = new jsPDF("l", "px", [1000, 500]);

    var parser = new DOMParser();

    for (let key of Object.keys(graphRefList)) {
      let graphT = graphRefList[key];
      if (graphT && graphT.current && graphT.current.chart) {
        let svgTxt = graphT.current.chart.getSVG();        
        let svgtextv1 = svgTxt.replaceAll('height="283"', 'height="500"');
        svgtextv1 = svgtextv1.replaceAll('height="186"', 'height="500"');
        svgtextv1 = svgtextv1.replaceAll(' 1200 283', ' 1200 500');  
        console.log("svgtextv1 : ",svgtextv1); 
        //svgtextv1 = svgtextv1.replaceAll('font-size:12px;', 'font-size:12px;');
        
        svgtextv1 = svgtextv1.replaceAll('font-size:10px', 'font-size:12px;');  
        
        svgtextv1 = svgtextv1.replaceAll('font-size:11px;', 'font-size:14px;');
        svgtextv1 = svgtextv1.replaceAll('font-size:8px;fill:#666666;', 'font-size:12px;fill:#000000;');              
      
        var doc = parser.parseFromString(svgtextv1, "image/svg+xml");
        
        const svg = doc.querySelectorAll("svg");          
        allSvg.push(svg[svg.length - 1]);
      }
    }

    const allGraphs = [...allCanvas, ...allSvg];

    if (!allGraphs.length) {
      setIsDownloading(false);
      return;
    }
    let generatePDF = (allGraphs) => {
      return new Promise(function (resolve, reject) {
        allGraphs.forEach(async (graph, ind) => {
          if(ind == 0){            
            let clientname = selectedClient.client_name;
            console.log("clientname.length:"+clientname.length);
            pdf.addImage(LOGO.biuLogoBase, "PNG", 430, 160, 100, 100);
            if(clientname.length > 30){
              pdf.text(selectedClient.client_name, 350, 300);
            } else {
              pdf.text(selectedClient.client_name, 460, 300);
            }
            pdf.text(` Report for the duration ${FROM_DATE}`, 400, 340);
            pdf.addPage();
          }
          const pdfCanvas = document.createElement("canvas");
          pdfCanvas.setAttribute("width", 400);
          pdfCanvas.setAttribute("height", 600);

          if (graph.nodeName === "svg") {
            const dataURI = await svgAsPngUri(graph,{},{scale: 2.5});
            pdf.addImage(
              dataURI,
              "PNG",
              // 160,
              100,
              120,
              graph.clientWidth,
              graph.clientHeight
            );
          } else if (graph.nodeName === "CANVAS") {
            const pdfctx = pdfCanvas.getContext("2d");
            pdfctx.drawImage(graph, 100, 120, 300, 349);

            pdf.addImage(pdfCanvas, "PNG", 0, 0);
          }

          pdf.setFontSize(12);
          if (diffInDays > 0) {
            // pdf.text(
            //   `Report for the duration ${FROM_DATE} to ${TO_DATE}`,
            //   500,
            //   90
            // );
          } else {
            // pdf.text(`Report for the duration ${FROM_DATE}`, 540, 90);
          }

          pdf.addImage(LOGO.biuLogoBase, "PNG", 10, 10, 50, 50);

          if (ind !== allGraphs.length - 1) {
            pdf.addPage();
          }
          if (ind === allGraphs.length - 1) {
            resolve();
          }
        });
      });
    };
    generatePDF(allGraphs).then(() => {
      //download the pdf
      let filename = "filename.pdf";
      if (selectedDashboard && selectedDashboard.name) {
        filename = `${selectedDashboard.name}_widgets.pdf`;
      }
      setIsDownloading(false);
      pdf.save(filename);
    });
  }

  return (
    <>
      {openModal ? (
        <DashboardNameModal
          show={openModal}
          onCancel={onCancelModalClick}
          modalTitle="Add Dashboard"
          confirmButtonText="Add Dashboard"
          onConfirm={onConfirmName}
          error={dashboardNameStatus}
          confirmText="Name"
        />
      ) : null}
      <ConfirmModal
        show={showDeleteConfirm}
        onCancel={onCancelDeleteWidget}
        modalTitle="Delete Widget"
        confirmButtonText="Delete"
        confirmText="Are you sure you want to delete this Widget?"
        onConfirm={deleteWidget}
      />
      <ConfirmModal
        show={showDashboardDeleteConfirm}
        onCancel={onCancelDeleteDashboard}
        modalTitle="Delete Dashboard"
        confirmButtonText="Delete"
        confirmText="Are you sure you want to delete this Dashboard?"
        onConfirm={deleteDashboard}
      />
      <ToastMessage
        show={widgetCreationStatus}
        setShow={setWidgetCreationStatus}
        message={widgetCreationStatus}
        type="success"
      />
      <div className="dashboardHeader">
        <div className="dashboardHeaderTop d-flex">
          <div className="dashboardMobileMenu">
            <button className="btn menuBtn" id="menuBtn">
              <MenuIcon />
            </button>
            {/* <img src={ConceptLogo} width="32" height="32" /> */}
          </div>
          <div className="dhLeft d-flex">
            <div className="dhLeftWrap d-flex align-items-center">
              <span
                onClick={() => history.push(DASHBOARD)}
                className="btnGoBack clickable"
              >
                <GoBackIcon />
              </span>
              <Dropdown className="dashboardDropdown">
                <Dropdown.Toggle variant="default">
                  {renderSelectedName()}
                  <ArrowDownIcon />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {selectedClient.client_name != CLIENT_NAME.cil && (
                    <Dropdown.Item>
                      <Button
                        onClick={() => setOpenModal(true)}
                        variant="outline-primary addDashboardBtn"
                      >
                        Add Dashboard
                      </Button>
                    </Dropdown.Item>
                  )}
                  {dashboardList && dashboardList.length
                    ? dashboardList.map((item) => (
                      <Dropdown.Item
                        key={item.id}
                        className={dashboard_id == item.id ? "active" : ""}
                        onClick={() => handleDropdownClick(item.id)}
                      >
                        {item.name}
                      </Dropdown.Item>
                    ))
                    : null}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="dhRight d-flex">
          {TRACKING_ALLOWED_CLIENTS.includes(clientId)?
            <>
              {Object.keys(pagination).length && (pagination.aPCount != 0 || pagination.aICount != 0)?
                <>
                  <div
                    className='number-bubble'
                    style={{
                      position: 'absolute',
                      top: '2%',
                      right: "16%",
                      backgroundColor: "rgb(0, 191, 255)",
                    }}
                  >
                    {pagination.aPCount}
                  </div>
                  <div
                    className='number-bubble'
                    style={{
                      position: 'absolute',
                      top: '2%',
                      right: "10%",
                      backgroundColor: "orange",
                    }}
                  >
                    {pagination.aICount}
                  </div>
                </>:""}
                <button
                  className="btn btnBlue addWidgetBtn mr-1"
                  variant="danger"
                  onClick={() => {history.push(ARTICLE_TRACKING)}}
                >
                  <TicketIcon color={'#fff'} /> <span>Article Tracking</span>
                </button>
            </>
            :""}
            {!apiInProgress ? (
              <AddWidget
                setWidgetCreationStatus={setWidgetCreationStatus}
                editWidgetData={editWidgetData}
                selectedDashboard={selectedDashboard}
                showTodaysFeedWidget={showTodaysFeedWidget}
                handleTodayFeedWidgeStatus={handleTodayFeedWidgeStatus}
                fetchWidgets={fetchWidgets}
                showButton={true}
                hideModal={showAddWidgetPopup}
              />
            ) : null}

            {/* <UserDropdown /> */}
          </div>
        </div>
      </div>

      <div className="mainContainer ">
        {showTodaysFeedWidget && (
          <div className="todaysFeed cls-db">
            <div className="titleRow">
              <h2>Today’s Feeds</h2>
              <button
                onClick={() => onWidgetDelete(WIDGET_TYPES.FEED_WIDGET)}
                className="btn feedDeleteIcon"
              >
                <div className="hasTooltip">
                  <DeleteIcon />
                  <span className="tooltipWrap center">Delete</span>
                </div>
              </button>
            </div>
            <div className="row">
              <div className="col-md-6">{id ? <DashboardFeeds /> : null}</div>
              <div className="col-md-6">{id ? <SocialFeeds /> : null}</div>
            </div>
          </div>
        )}
        <div className={widgets.length ? "widgetWrap" : ""}>
          {apiInProgress && <Loader />}
          {!apiInProgress && widgets && !!widgets.length ? (
            <>
              {/* only two instance of WidgetFilter Component. Add key manually */}
              <WidgetFilters
                key={"WidgetFilter-1"}
                widgetLoaded={widgetLoaded}
                isDownloading={isDownloading}
                downloadAll={downloadAll}
                widgets={widgets}
                onWidgetFiltered={handleFilteredWidget}
              />

              <div className="widgetColumnWrap">
                {filteredWidgets && !!filteredWidgets.length ? (
                  <div className="row">
                    <WidgetList
                      key={"WidgetFilter-2"}
                      enableDownloadFn={enableDownloadFn}
                      filteredWidgets={filteredWidgets}
                      history={history}
                      selectedDashboard={selectedDashboard}
                      showTodaysFeedWidget={showTodaysFeedWidget}
                      handleTodayFeedWidgeStatus={handleTodayFeedWidgeStatus}
                      fetchWidgets={fetchWidgets}
                      setWidgetCreationStatus={setWidgetCreationStatus}
                      setFilteredWidgets={setFilteredWidgets}
                      widgets={widgets}
                      setWidgets={setWidgets}
                      setGraphRefList={(key, graphRef) =>
                        setGraphRefList((prevObj) => ({
                          ...prevObj,
                          [key + ""]: graphRef,
                        }))
                      }
                    />
                  </div>
                ) : (
                  <div className="row">
                    <h2
                      style={{
                        textAlign: "center",
                        width: "100%",
                        margin: "100px",
                      }}
                    >
                      No Widgets Found!
                    </h2>
                  </div>
                )}
              </div>
            </>
          ) : (
            !apiInProgress &&
            id &&
            !showTodaysFeedWidget && (
              <div className="row">
                <h2
                  style={{
                    textAlign: "center",
                    width: "100%",
                    margin: "50px 0",
                  }}
                >
                  No Widgets Added
                </h2>
              </div>
            )
          )}
        </div>
      </div>
      {/* Floating Chatbot Icon */}
      {/* <button className={"chatbot-icon "+(hasNewTicket?"highlight":"")} onClick={toggleChatbot}>
        <EmailIcon fill={"#ffffff"} />
      </button>
      {/* Chatbot UI *
      {isChatbotOpen && (
        <div className="chatbot-container">
          <Tickets toggleChatbot={toggleChatbot} />
        </div>
      )} */}
    </>
  );
};
